import React, { memo, useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import { api, cookie, resource } from 'app';
import { Provider as UserProvider } from 'app/user';
import { apiUrl, cookieOptions } from 'config';
import Layout from 'components/Layout';
import Loading from 'components/Loading';
import GlobalStyle from 'packages/ui/GlobalStyle';
import StyledUp from 'packages/ui/StyledUp';

import Virgool from 'routes/virgool/edit';
import Virgools from 'routes/virgool';
import Campaigns from 'routes/campaigns';
import Campaign from 'routes/campaign';
import CreateCampaign from 'routes/createCampaign';
import CampaignAvailableAudience from 'routes/campaignAvailableAudience';
import AdsOrder from 'routes/adsOrder';
import Search from 'routes/search';
import Events from 'routes/events';
import Webinar from 'routes/webinar';
import WebinarStatus from 'routes/webinarStatus';
import CreateRefund from 'routes/refunds/new';
import Refunds from './routes/refunds';
import Chart from './routes/chart';
import Attendees from 'routes/attendees';
import Promotions from './routes/promotions';
import CreatePromotion from './routes/promotions/new';
import CreateEvandPromot from './routes/evandPromot/form';
import Credits from './routes/credits';
import CreateCredit from './routes/credits/new';
import Speakers from './routes/speakers';
import EditSpeaker from './routes/speakers/edit';
import Transactions from './routes/transactions';
import Sliders from './routes/sliders';
import CreateSlider from './routes/sliders/new';
import Deposits from './routes/deposits';
import CreateDeposit from './routes/deposits/new';
import Orders from './routes/orders';
import EventSettings from './routes/events/components/EventSettings';
import CustomOrders from './routes/customOrders';
import CreateCustomOrder from './routes/customOrders/new';
import Users from './routes/users';
import UserEdit from './routes/users/Form';
import Organizations from './routes/organizations';
import EditOrganization from './routes/organizations/edit';
import Revisions from './routes/events/revisions';
import EventFinancialReport from './routes/events/financialReport';
import Logs from './routes/logs';
import RecordedVideos from './routes/recordedVideos';

// import the library
import { library } from '@fortawesome/fontawesome-svg-core';

// import your icons
import { fas } from '@fortawesome/free-solid-svg-icons';
import Promotes from './routes/evandPromot';

import CreateBalePost from './routes/balePosts/form';
import Circles from './routes/circles';
import CreateCircle from './routes/circles/new';
import EditCircle from './routes/circles/edit';
import { evandUrl } from './config';

// function refreshJwt() {
//   //remove this shit if about a year passed from this commit
//   //it needed to update the jwt domain for the users that login during transportation
//   //server to hamravesh
//   const jwt = cookie.get('jwt');

//   if (jwt) {
//     cookie.remove('jwt');
//     cookie.set('jwt', jwt, { ...cookieOptions });
//   }
// }

cookie.setGlobalOptions(cookieOptions);

resource.setApiBase(apiUrl);

function transform(user) {
  return {
    avatarUrl: user.avatar_url,
    displayName: `${user.first_name} ${user.last_name}`,
    email: user.email,
    mobile: user.mobile
  };
}

function App() {
  const [status, setStatus] = useState('');
  const [user, setUser] = useState();

  useEffect(() => {
    if (cookie.get('jwt')) {
      // refreshJwt();
      api.headers.Authorization = cookie.get('jwt');
      resource.setClientHeaders({
        Authorization: cookie.get('jwt')
      });
      setStatus('loading');
    }
  }, []);

  useEffect(() => {
    api
      .rawGet('/users/me')
      .then(response => response.json())
      .then(response => {
        setStatus('loaded');
        setUser(transform(response.data));
      })
      .catch(error => {
        if (error.status_code === 401) {
          cookie.remove('jwt');
          window.location.href = `${evandUrl}/auth/login?redirect_url=${window.location.href}`;
        }
        setStatus('failed');
      });
  }, []);

  if (status === 'loaded') {
    return (
      <UserProvider value={user}>
        <BrowserRouter>
          <Layout>
            <Switch>
              <Route component={Campaigns} path="/campaigns" exact />
              <Route component={CreateCampaign} path="/campaigns/create" />
              <Route component={CampaignAvailableAudience} path="/campaigns/available-audience" />
              <Route component={Campaign} path="/campaigns/:id" />
              <Route component={Virgool} path="/virgool/:id" />
              <Route component={Virgools} path="/virgool" exact />
              <Route component={AdsOrder} path="/ads" />
              <Route component={Search} path="/search" />
              <Route component={Events} path="/events" exact />
              <Route component={Webinar} path="/events/:slug/webinar" />
              <Route component={Revisions} path="/events/:id/revisions" exact />
              <Route component={EventFinancialReport} path="/events/:slug/financial-report" exact />
              <Route component={EventSettings} path="/events/:id/:slug" />
              <Route component={WebinarStatus} path="/webinar-status" />
              <Route component={CreateRefund} path="/refunds/new" />
              <Route component={Refunds} path="/refunds" />
              <Route component={Chart} path="/user-stats" />
              <Route component={Attendees} path="/attendees" exact />
              <Route component={Promotions} path="/promotions" exact />
              <Route component={CreatePromotion} path="/promotions/new" exact />
              <Route component={Promotes} path="/evand-promot" exact />
              <Route component={CreateEvandPromot} path="/evand-promot/:type" exact />
              <Route component={CreateBalePost} path="/bale-posts/:id" exact />
              <Route component={CreateCircle} path="/circles/new" exact />
              <Route component={Circles} path="/circles" exact />
              <Route component={EditCircle} path="/circles/:slug" exact />
              <Route component={Credits} path="/credits" exact />
              <Route component={CreateCredit} path="/credits/new" exact />
              <Route component={EditSpeaker} path="/mentors/:id" exact />
              <Route component={Speakers} path="/mentors" exact />
              <Route component={Transactions} path="/transactions" exact />
              <Route component={CreateSlider} path="/sliders/:id" exact />
              <Route component={Sliders} path="/sliders" exact />
              <Route component={CreateDeposit} path="/deposits/:id" exact />
              <Route component={Deposits} path="/deposits" exact />
              <Route component={Orders} path="/orders" exact />
              <Route component={CustomOrders} path="/custom-orders" exact />
              <Route component={CreateCustomOrder} path="/custom-orders/:id" exact />
              <Route component={UserEdit} path="/users/:id" exact />
              <Route component={Users} path="/users" />
              <Route component={Organizations} path="/organizations" exact />
              <Route component={EditOrganization} path="/organizations/:slug" exact />
              <Route component={Logs} path="/logs" />
              <Route component={RecordedVideos} path="/recorded-videos" exact />
            </Switch>
          </Layout>
        </BrowserRouter>
      </UserProvider>
    );
  }

  return <Loading />;
}

const AppPure = memo(App);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.Fragment>
    <StyledUp isRTL>
      <GlobalStyle />
      <AppPure />
    </StyledUp>
  </React.Fragment>
);
library.add(fas);
